import classNames from 'classnames';
import React, { useState, useRef } from 'react';
import { FaCheck, FaRegCopy, FaTimes } from 'react-icons/fa';

export const useCopyToClipboard = ({ timeout = 3000, errorTimeout = 10000, noTextMessage = 'No text to copy' }) => {
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [error, setError] = useState(null);
    const tout = useRef();
    const copyText = async (text) => {
        tout.current && clearTimeout(tout.current);
        try {
            if (!text) throw new Error(noTextMessage);
            await navigator.clipboard.writeText(text);
            setIsSuccess(true);
            setIsError(false);
            setError(null);
            tout.current = setTimeout(() => {
                setIsSuccess(false);
            }, timeout);
        } catch (error) {
            console.error(error);
            tout.current && clearTimeout(tout.current);
            setIsError(true);
            setIsSuccess(false);
            setError(error.message);
            if (errorTimeout) {
                tout.current = setTimeout(() => {
                    setError(null);
                    setIsError(null);
                    tout.current && clearTimeout(tout.current);
                }, errorTimeout);
            }
        }
    };
    return [copyText, { isSuccess, isError, error }];
};

const CopyToClipboard = ({ text = '', label = 'Click to Copy', successLabel = 'Copied!', className }) => {
    const [copyText, { isSuccess, isError }] = useCopyToClipboard({});
    return (
        <button
            className={classNames('btn btn-link', className)}
            type="button"
            disabled={isSuccess}
            onClick={() => copyText(text)}
        >
            {!isSuccess && !isError && (
                <>
                    <FaRegCopy className="icon-align" aria-hidden /> {label}
                </>
            )}
            {isSuccess && !isError && (
                <span className="txt-success">
                    <FaCheck className="icon-align" aria-hidden /> {successLabel}
                </span>
            )}
            {!isSuccess && isError && (
                <>
                    <FaTimes className="icon-align" aria-hidden /> Error
                </>
            )}
        </button>
    );
};

export default CopyToClipboard;
